/*jshint esversion: 6 */

$(document).ready(function() {

    const carouselHero = document.getElementById("carouselHero");

    if (carouselHero && carouselHero.childElementCount > 1) {
        $("#carouselHero").owlCarousel({
            items: 1,
            nav: true,
            loop: true,
            dots: false,
            autoplay: true,
            autoplayTimeout: 7000,
        });
    }

    jQuery(".carouselBrands").owlCarousel({
        margin: 40,
        nav: false,
        loop: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 10000,
        responsive: {
            0: {
                items: 2
            },
            768: {
                items: 4
            },
            992: {
                items: 6
            }
        }
    });

});